// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".normal-text[data-v-7aa69c62]{letter-spacing:0}", "",{"version":3,"sources":["webpack://./src/components/application/VProfileMenu/ProfileMenu.styl"],"names":[],"mappings":"AAAA,8BACE,gBAAgB","sourcesContent":[".normal-text\n  letter-spacing: 0\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
